export enum EConceitoValorFrete {
    ValorFixo = 1,
    FormulaPersonalizada = 2,
}
